__turbopack_context__.v({
  "appsList": "ProfileTabSecurity-module__o1jsKW__appsList",
  "enabledStatus": "ProfileTabSecurity-module__o1jsKW__enabledStatus",
  "enabledStatusIcon": "ProfileTabSecurity-module__o1jsKW__enabledStatusIcon",
  "enabledStatusText": "ProfileTabSecurity-module__o1jsKW__enabledStatusText",
  "infoBox": "ProfileTabSecurity-module__o1jsKW__infoBox",
  "infoBoxContent": "ProfileTabSecurity-module__o1jsKW__infoBoxContent",
  "infoBoxIcon": "ProfileTabSecurity-module__o1jsKW__infoBoxIcon",
  "mfaDigits": "ProfileTabSecurity-module__o1jsKW__mfaDigits",
  "mfaDigitsError": "ProfileTabSecurity-module__o1jsKW__mfaDigitsError",
  "qrContainer": "ProfileTabSecurity-module__o1jsKW__qrContainer",
  "qrImage": "ProfileTabSecurity-module__o1jsKW__qrImage",
  "qrSecretCode": "ProfileTabSecurity-module__o1jsKW__qrSecretCode",
  "qrSecretLabel": "ProfileTabSecurity-module__o1jsKW__qrSecretLabel",
  "stepDescription": "ProfileTabSecurity-module__o1jsKW__stepDescription",
  "stepHeader": "ProfileTabSecurity-module__o1jsKW__stepHeader",
  "stepNumber": "ProfileTabSecurity-module__o1jsKW__stepNumber",
  "stepTitle": "ProfileTabSecurity-module__o1jsKW__stepTitle",
});
